/* attempt to recreate the JS based on source map(s) */

import './layout/theme';

console.log('layout.theme.js run');
